/* tslint:disable */
/* eslint-disable */
/**
 * Agent service API
 * Service for credentials management
 *
 * The version of the OpenAPI document: 1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { CertificateEdgeItem } from './CertificateEdgeItem';
import {
    CertificateEdgeItemFromJSON,
    CertificateEdgeItemFromJSONTyped,
    CertificateEdgeItemToJSON,
} from './CertificateEdgeItem';
import type { Logo } from './Logo';
import {
    LogoFromJSON,
    LogoFromJSONTyped,
    LogoToJSON,
} from './Logo';

/**
 * Related brand credential
 * @export
 * @interface BrandEdgedCredentialDetailedDto
 */
export interface BrandEdgedCredentialDetailedDto {
    /**
     * Self-Addressing Identifier. Primary credential id
     * @type {string}
     * @memberof BrandEdgedCredentialDetailedDto
     */
    said?: string;
    /**
     * 
     * @type {string}
     * @memberof BrandEdgedCredentialDetailedDto
     */
    type?: BrandEdgedCredentialDetailedDtoTypeEnum;
    /**
     * 
     * @type {string}
     * @memberof BrandEdgedCredentialDetailedDto
     */
    status?: BrandEdgedCredentialDetailedDtoStatusEnum;
    /**
     * Human-readable Identifier for Credential. Set by creator of the credential
     * @type {string}
     * @memberof BrandEdgedCredentialDetailedDto
     */
    credentialAlias?: string;
    /**
     * Autonomic Identifier
     * @type {string}
     * @memberof BrandEdgedCredentialDetailedDto
     */
    issueeAid?: string;
    /**
     * Human-readable Identifier for AID
     * @type {string}
     * @memberof BrandEdgedCredentialDetailedDto
     */
    issueeAlias?: string;
    /**
     * AID of issuer - who created that credential
     * @type {string}
     * @memberof BrandEdgedCredentialDetailedDto
     */
    issuerAid?: string;
    /**
     * Human-readable Identifier for AID
     * @type {string}
     * @memberof BrandEdgedCredentialDetailedDto
     */
    issuerAlias?: string;
    /**
     * When the credential was issued in format yyyy-MM-dd'T'HH:mm:ss.SSSSSSXXXXX
     * @type {string}
     * @memberof BrandEdgedCredentialDetailedDto
     */
    issuedAt?: string;
    /**
     * When the credential was revoked if it was revoked. Format yyyy-MM-dd'T'HH:mm:ss.SSSSSSXXXXX
     * @type {string}
     * @memberof BrandEdgedCredentialDetailedDto
     */
    revokedAt?: string;
    /**
     * Schema ID of the credential
     * @type {string}
     * @memberof BrandEdgedCredentialDetailedDto
     */
    schemaId?: string;
    /**
     * 
     * @type {{ [key: string]: CertificateEdgeItem; }}
     * @memberof BrandEdgedCredentialDetailedDto
     */
    certificateChainMap?: { [key: string]: CertificateEdgeItem; };
    /**
     * 
     * @type {string}
     * @memberof BrandEdgedCredentialDetailedDto
     */
    brandName?: string;
    /**
     * 
     * @type {Logo}
     * @memberof BrandEdgedCredentialDetailedDto
     */
    logo?: Logo;
    /**
     * 
     * @type {Array<string>}
     * @memberof BrandEdgedCredentialDetailedDto
     */
    categories?: Array<string>;
}


/**
 * @export
 */
export const BrandEdgedCredentialDetailedDtoTypeEnum = {
    Unknown: 'UNKNOWN',
    Dossier: 'DOSSIER',
    OrgIdentity: 'ORG_IDENTITY',
    Range: 'RANGE',
    Brand: 'BRAND',
    TnAlloc: 'TN_ALLOC',
    DelSig: 'DEL_SIG',
    Qvi: 'QVI',
    Root: 'ROOT',
    A2PCampaign: 'A2P_CAMPAIGN'
} as const;
export type BrandEdgedCredentialDetailedDtoTypeEnum = typeof BrandEdgedCredentialDetailedDtoTypeEnum[keyof typeof BrandEdgedCredentialDetailedDtoTypeEnum];

/**
 * @export
 */
export const BrandEdgedCredentialDetailedDtoStatusEnum = {
    Active: 'ACTIVE',
    Expired: 'EXPIRED',
    Revoked: 'REVOKED'
} as const;
export type BrandEdgedCredentialDetailedDtoStatusEnum = typeof BrandEdgedCredentialDetailedDtoStatusEnum[keyof typeof BrandEdgedCredentialDetailedDtoStatusEnum];


/**
 * Check if a given object implements the BrandEdgedCredentialDetailedDto interface.
 */
export function instanceOfBrandEdgedCredentialDetailedDto(value: object): boolean {
    return true;
}

export function BrandEdgedCredentialDetailedDtoFromJSON(json: any): BrandEdgedCredentialDetailedDto {
    return BrandEdgedCredentialDetailedDtoFromJSONTyped(json, false);
}

export function BrandEdgedCredentialDetailedDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): BrandEdgedCredentialDetailedDto {
    if (json == null) {
        return json;
    }
    return {
        
        'said': json['said'] == null ? undefined : json['said'],
        'type': json['type'] == null ? undefined : json['type'],
        'status': json['status'] == null ? undefined : json['status'],
        'credentialAlias': json['credentialAlias'] == null ? undefined : json['credentialAlias'],
        'issueeAid': json['issueeAid'] == null ? undefined : json['issueeAid'],
        'issueeAlias': json['issueeAlias'] == null ? undefined : json['issueeAlias'],
        'issuerAid': json['issuerAid'] == null ? undefined : json['issuerAid'],
        'issuerAlias': json['issuerAlias'] == null ? undefined : json['issuerAlias'],
        'issuedAt': json['issuedAt'] == null ? undefined : json['issuedAt'],
        'revokedAt': json['revokedAt'] == null ? undefined : json['revokedAt'],
        'schemaId': json['schemaId'] == null ? undefined : json['schemaId'],
        'certificateChainMap': json['certificateChainMap'] == null ? undefined : (mapValues(json['certificateChainMap'], CertificateEdgeItemFromJSON)),
        'brandName': json['brandName'] == null ? undefined : json['brandName'],
        'logo': json['logo'] == null ? undefined : LogoFromJSON(json['logo']),
        'categories': json['categories'] == null ? undefined : json['categories'],
    };
}

export function BrandEdgedCredentialDetailedDtoToJSON(value?: BrandEdgedCredentialDetailedDto | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'said': value['said'],
        'type': value['type'],
        'status': value['status'],
        'credentialAlias': value['credentialAlias'],
        'issueeAid': value['issueeAid'],
        'issueeAlias': value['issueeAlias'],
        'issuerAid': value['issuerAid'],
        'issuerAlias': value['issuerAlias'],
        'issuedAt': value['issuedAt'],
        'revokedAt': value['revokedAt'],
        'schemaId': value['schemaId'],
        'certificateChainMap': value['certificateChainMap'] == null ? undefined : (mapValues(value['certificateChainMap'], CertificateEdgeItemToJSON)),
        'brandName': value['brandName'],
        'logo': LogoToJSON(value['logo']),
        'categories': value['categories'],
    };
}

